import React from 'react';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import targetLogoSmall from '@icons/targetLogoSmall';
import connectLogoSmall from '@icons/connectLogoSmall';
import webvisitorsLogoSmall from '@icons/webvisitorsLogoSmall';
import datacareLogoSmall from '@icons/datacareLogoSmall';
import promoteLogoSmall from '@icons/promoteLogoSmall';
import dealfrontLogoSmall from '@icons/dealfrontLogoSmall';
import browserExtensionSmall from '@icons/browserExtensionSmall';
import buyerIntentSignalLogoSmall from '@icons/buyerIntentSignalSmall';
import companyToIpSmall from '@icons/companyToIpSmall';
import ipToCompanySmall from '@icons/ipToCompanySmall';

import salesforceIcon from '@icons/salesforceIcon';
import hubSpotIcon from '@icons/hubSpotIcon';
import pipedriveIcon from '@icons/pipeDriveIconSmall';
import googleAdsIcon from '@icons/googleAdsIcon';

import IconLink from '@components/IconLink';
import { signUpUrl } from '@helpers/urls';

import SuccessStoryCTA from '../../ctas/SuccessStory';

export const Platform = () => {
  const { t } = useTranslation();

  const { language, path } = useI18next();

  const isWebVisitorsPage =
    path.includes('/solutions/web-visitor-tracking/') ||
    path.includes('/web-visitors/');

  return {
    label: t('nav_platform_page'),
    iconLink: (
      <IconLink
        theme="dark"
        href={'/integrations'}
        classes={'view-all-integrations'}
      >
        {t('view_all_integrations')}
      </IconLink>
    ),
    submenus: [
      {
        label: t('nav_label_product'),
        columns: 2,
        subgroups: [
          {
            label: t('nav_our_platform'),
            icon: dealfrontLogoSmall,
            href: '/platform',
            caption: t('nav_our_platform_caption'),
            grid: true,
            mobOrder: 1,
          },  
          {
            label: t('nav_datacare_page'),
            icon: datacareLogoSmall,
            href: '/datacare',
            caption: t('nav_datacare_caption'),
            grid: true,
            mobOrder: 5,
          },
          {
            label: t('nav_webvisitors_page'),
            icon: webvisitorsLogoSmall,
            href: '/web-visitors',
            caption: t('nav_webvisitors_caption'),
            grid: true,
            mobOrder: 2,
          },
          {
            label: t('nav_promote_page'),
            icon: promoteLogoSmall,
            href: '/promote',
            caption: t('nav_promote_caption'),
            grid: true,
            mobOrder: 6,
          },
          {
            label: t('nav_target_page'),
            icon: targetLogoSmall,
            href: '/target',
            caption: t('nav_target_caption'),
            grid: true,
            mobOrder: 3,
          },              
          {
            label: '',
            href: '/',
            caption: '',
            grid: true,
            spacer: true,
            mobOrder: 7,
          }, 
          {
            label: t('nav_connect_page'),
            icon: connectLogoSmall,
            href: '/connect',
            caption: t('nav_connect_caption'),
            grid: true,            
            mobOrder: 5,
          },   
        ],
      },
      {
        label: t('nav_advanced_features'),
        subgroups: [
          {
            label: t('nav_label_df_ai'),
            href: '/platform/features/ai-insights/',
            caption: t('nav_label_df_ai_caption'),
            icon: companyToIpSmall,
            grid: true,
          },
          {
            label: 'Browser Extension',
            href: '/browser-extension',
            caption: t('nav_browser_extension_caption'),
            icon: browserExtensionSmall,
            grid: true,
          },
          {
            label: t('nav_sales_buyer_intent_signals_page'),
            icon: buyerIntentSignalLogoSmall,
            href: '/solutions/buying-intent-signals',
            caption: t('nav_sales_buyer_intent_signals_page_caption'),
            grid: true,
          },
          {
            label: t('nav_ip_to_company'),
            href: '/ip-enrich-api/',
            caption: t('nav_ip_to_company_desc'),
            icon: ipToCompanySmall,
            grid: true,
          },
        ],
      },
      {
        label: t('nav_integrations_page'),
        subgroups: [
          {
            label: 'Salesforce',
            href: '/integrations/salesforce',
            caption: t('nav_salesforce'),            
            icon: salesforceIcon,
            grid: true,
          },
          {
            label: 'HubSpot',
            href: '/integrations/hubspot',
            caption: t('nav_hubspot'),  
            icon: hubSpotIcon,
            grid: true,
          },
          {
            label: 'Pipedrive',
            href: '/integrations/pipedrive',
            caption: t('nav_pipedrive'),  
            icon: pipedriveIcon,
            grid: true,
          },
          {
            label: 'Google Ads',
            href: '/integrations/google-ads',
            caption: t('nav_google_ads'),  
            icon: googleAdsIcon,
            grid: true,
          },
        ],
      },
    ],
    ctas: [
      {
        label: t('nav_latest_success_stories'),
        content: <SuccessStoryCTA limit={4} />,
      },
    ],
  };
};
